<template>
  <autocomplete :disabled="disabled" v-if="(staticItems && addresses) || !staticItems" ref="suggestions" v-model="searchQuery" :options="options" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :staticItems="(staticItems && addresses && addresses.length > 0) ? addresses : null" :required="required">
    <template #item="props">
      <template v-if="props.item && props.item.Icon && props.item.Icon.URL">
        <div class="image-wrap" :style="{'backgroundImage': 'url('+ props.item.Icon.URL + ')' }"></div>
      </template>
      <span class="name" v-if="props.item && props.item.main_text">
        <font-awesome-icon class="text-secondary " icon="map-marker-alt" size="sm" />
        {{props.item.main_text + ', ' + props.item.secondary_text }}
      </span>
      <span class="name" v-if="props.item && props.item.plusCode">
        <small class="text-danger text-uppercase"><small>plus code</small></small>
        {{props.item.code}}
      </span>
      <span class="name" v-if="props.item && props.item.coordinates">
        <small class="text-danger text-uppercase"><small v-translate>Coordinates</small></small>
        {{props.item.coords}}
      </span>
      <span v-if="props.item.reference"><font-awesome-icon class="text-secondary " icon="bookmark" size="sm" /> <strong>{{props.item.reference}}</strong><br>{{props.item.place.formatted_address}}</span>
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  emits: ['input', 'selected'],
  name: 'AddressAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    staticItems: {
      type: Boolean
    },
    minCharacter: {
      type: Number,
      default: 0
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.$gettext('Street and number'),
        inputClass: 'form-control'
      },
      staticItemsArray: this.$store.getters.addresses,
      addresses: []
    }
  },
  created() {
    if (this.staticItems) {
      const staticItems = this.profile.company?.stores || []
      this.addresses = this.staticItemsArray = (staticItems.concat(JSON.parse(localStorage.getItem('savedAddresses'))) || this.$store.getters.addresses).filter(Boolean)
    }
    this.searchQuery = this.preQuery
  },
  methods: {
    onInputChange(query) {
      this.$emit('input', query)
      let url = ''
      if (typeof query !== 'object') {
        if (query.trim().length < this.minCharacter && this.staticItems) {
          if (query.trim().length > 0) {
            return this.addresses.filter((address) => {
              return ((address.reference && address.reference.toLowerCase().includes(query.toLowerCase())) ||
                (address.contact && address.contact.toLowerCase().includes(query.toLowerCase())) ||
                (address.place && address.place.formatted_address.toLowerCase().includes(query.toLowerCase())))
            })
          } else {
            return this.addresses
          }
        }
      } else {
        return this.addresses || null
      }
      if (query.trim().length >= this.minCharacter) {
        const plusCodesRegexp = new RegExp(/(^|\s)([23456789CFGHJMPQRVWX]{4,6}\+[23456789CFGHJMPQRVWX]{2,3})(\W+\w+)+(\s|$)|(^|\s)([23456789C][23456789CFGHJMPQRV][23456789CFGHJMPQRVWX]{6}\+[23456789CFGHJMPQRVWX]{2,3})(\s|$)/i)
        const coordinatesRegexp = new RegExp(/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/)

        if (!plusCodesRegexp.test(query) && !coordinatesRegexp.test(query)) {
          url = this.$appConfig.api.baseUrl + 'autocomplete?query=' + encodeURI(query.replaceAll('#', '%23 ').replaceAll('+', '%2B'))
          return new Promise(resolve => {
            this.$http.get(url).then(response => {
              resolve(response.data)
            })
          })
        } else if (coordinatesRegexp.test(query)) {
          return [{ coords: query, coordinates: true }]
        } else {
          return [{ code: query, plusCode: true }]
        }
      }
    },
    onSearchItemSelected(item) {
      if (item.plusCode) {
        this.searchQuery = item.code
      } else if (item.coordinates) {
        this.searchQuery = item.coords
      } else if (item.main_text) {
        this.searchQuery = item.main_text + ', ' + item.secondary_text
      } else if (item.place.formatted_address) {
        this.searchQuery = item.place.formatted_address
      }
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
